import { BrowserStorage } from '@atc/browser-storage';
import getConsumerMetadata from './getConsumerMetadata';
import fetchConsumerId from './fetchConsumerId';
const CONSUMER_METADATA_KEY = 'CONSUMER_METADATA';
async function getAndSaveConsumerMetadata({
  email,
  brand,
  shouldUpdateConsumerMetadata = false,
  isLoggedIn
}) {
  if (isLoggedIn) {
    return getConsumerMetadata();
  }
  const consumerMetadataCache = new BrowserStorage(CONSUMER_METADATA_KEY, {
    persist: false
  });

  // when shouldUpdateConsumerMetadata is true, hit the fetcher to get consumerId,
  // and later save it to the browser storage
  let consumerMetadata;
  if (shouldUpdateConsumerMetadata) {
    try {
      const {
        consumerId: myConsumerId,
        status,
        errorMessage
      } = await fetchConsumerId({
        email,
        brand
      });
      consumerMetadata = {
        email,
        myConsumerId
      };
      if (window && window.newrelic && status !== '200') {
        window.newrelic.addPageAction('ConsumerMetadataAction', {
          status,
          errorMessage
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      if (window && window.newrelic) {
        window.newrelic.addPageAction('ConsumerMetadataAction', {
          errorMessage: error
        });
      }
    }
  } else {
    consumerMetadata = consumerMetadataCache.getItem() || {};
  }
  const result = {
    email: consumerMetadata?.email || email,
    myConsumerId: consumerMetadata?.myConsumerId
  };
  if (shouldUpdateConsumerMetadata) {
    consumerMetadataCache.setItem(result);
  }
  return result;
}
export default getAndSaveConsumerMetadata;